import { ReactNode } from 'react';
import { useNavigation } from 'hooks/useNavigation';
import { NsxAddressSelector } from 'components/common/nsx-address-selector/NsxAddressSelector';

export const testId = 'quoteSectionTestId';

type QuoteSectionProps = {
  title?: string;
  children?: ReactNode;
};

export const QuoteSection = ({ title = '', children }: QuoteSectionProps) => {
  const { next, eventTypes } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <section data-testid={testId}>
      <h2>{title}</h2>
      {children}
      <NsxAddressSelector handleGoNext={handleGoNext} />
    </section>
  );
};
